import { Widget } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';

import { Contact } from 'lucide-react';

import DisabledEmailField from './DisabledEmailField';
import { PROPS } from './constants';
import useContactInformationFields from './useContactInformationFields';

import { YOUR_INFO_CLASS_NAMES } from '../constants';

const ContactInformationFields: React.FunctionComponent = function () {
  const { emailValidation, phoneValidation, onPhoneBlur } =
    useContactInformationFields();
  return (
    <>
      <div className={YOUR_INFO_CLASS_NAMES.titleWrapper}>
        <Contact size={20} />
        <Text {...PROPS.pageTitle} />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 xl:grid-cols-2 gap-x-3 md:gap-x-4">
        <div className="col-span-1 sm:col-span-2 md:col-span-1 xl:col-span-2">
          <DisabledEmailField validation={emailValidation} />
        </div>
        <Widget.CreditCustomerDetailsMobile
          {...PROPS.mobileNumber}
          validation={phoneValidation}
          onBlur={onPhoneBlur}
        />
        <Widget.CreditCustomerDetailsTelephone
          {...PROPS.phoneNumber}
          validation={phoneValidation}
          onBlur={onPhoneBlur}
        />
      </div>
    </>
  );
};

export default ContactInformationFields;
